// Junais 06-09-2022
import * as types from '../actions/securityactionstypes'

let initialState={
    userSession: null,
}
const securityReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_USER_SESSION:
            return {
                ...state,
                userSession: action.payload,                
            }
        default:
            return state;
    }
}

export default securityReducer;